export default __webpack_public_path__ + "static/media/Spin general_Interactive LightMix0021.065d4990.webp";